angular.module("Main").controller("Step2Controller", ["$rootScope", "$scope", "$window", "$state", "$stateParams", "$localStorage", "$uibModal", "BookingService",
    "SessionService", "BookingCalculationService",
    function ($rootScope, $scope, $window, $state, $stateParams, $localStorage, $uibModal, BookingService, SessionService, BookingCalculationService) {
        var vm = this;

        let now = new Date();
        vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        vm.KW = moment().isoWeek();
        vm.now = moment();
        vm.nowEndDate = moment().add(6, 'days');
        vm.KWEnd = moment(vm.nowEndDate).isoWeek();
        vm.currentYear = moment().year();
        vm.cookies = SessionService.checkSession();
        if (!_.isNil(vm.cookies.meetingData)) {
            vm.meetingData = vm.cookies.meetingData;
        }

        var loginHandler = $rootScope.$on("login", function () {
            checkUser();
        });
        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            $localStorage.user = {};
            unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
        });

        var maxDate = new Date();
        vm.selectedTerminarten = null;
        vm.selectedNrs = {};
        vm.ressourcenBeliebig = true;
        vm.selectedRessourcen = [];
        vm.openFilterRessources = true;
        vm.openedMenuBar = false;
        vm.hours = [];

        if (screen.width < 600) {
            vm.isMobilePhone = true;
            vm.weekView = true
        } else {
            vm.isMobilePhone = false;
            vm.weekView = true;
        }

        vm.setDayView = function () {
            vm.weekView = false;
            var now = new Date();
            vm.date = new Date(now);
            initPlan(vm.date);
        };

        vm.setWeekView = function () {
            vm.weekView = true;
            initPlan();
        };


        vm.openCloseFilterRessources = function () {
            if (vm.openFilterRessources === false) {
                vm.openFilterRessources = true;
            } else {
                vm.openFilterRessources = false;
            }
        };

        loadConfigs();

        function getKursbuchungLayoutKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
                vm.layoutSlotFree = {
                    borderColor: vm.kursbuchungConfig.Step1WochentageHintergrund,
                    color: vm.kursbuchungConfig.Step2ItemSchrift,
                    background: vm.kursbuchungConfig.Step1ButtonsHintergrund
                };
                vm.activeBackground = {background: vm.kursbuchungConfig.Step1ButtonsHintergrundAktiv, color: vm.kursbuchungConfig.Step1ButtonsSchriftAktiv};
                vm.notActiveBackground = {background: vm.kursbuchungConfig.Step1ButtonsHintergrund, color: vm.kursbuchungConfig.Step1ButtonsSchrift};
                vm.activeBackgroundWochentage = {
                    background: vm.kursbuchungConfig.Step1WochentageHintergrundAktiv,
                    color: vm.kursbuchungConfig.Step1WochentageSchriftAktiv
                };
                vm.notActiveBackgroundWochentage = {
                    background: vm.kursbuchungConfig.Step1WochentageHintergrund,
                    color: vm.kursbuchungConfig.Step1WochentageSchrift
                };
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.TerminbuchungTimeSlider = data.TerminbuchungTimeSlider;
            });
            getKursbuchungLayoutKonfiguration();
        }


        vm.loadBackgrounds = function () {
            setTimeout(function () {
                $scope.$broadcast('rzSliderForceRender');
                loadConfigs();
                if (vm.SliderActiv === 1)
                    changeBackground();
            }, 1);
        };

        function changeBackground() {
            let b = document.getElementsByClassName('rz-tick');
            _.forEach(b, function (tick) {
                tick.style.backgroundColor = vm.kursbuchungConfig.TimeSliderInaktiv;
            });
            let a = document.getElementsByClassName('rz-tick rz-selected');
            _.forEach(a, function (tick) {
                tick.style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            });

            document.getElementsByClassName('rz-bar')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderInaktiv;
            document.getElementsByClassName('rz-pointer-min')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            document.getElementsByClassName('rz-pointer-max')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            document.getElementsByClassName('rz-selection')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
        }

        if (!SessionService.getSessionId()) {
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
        } else
            start();

        function start() {
            var now = new Date();
            vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            init();
        }


        function getTicksForSlider(sliderStart, sliderEnde) {
            var quarterHours = ["00", "30"];
            vm.hours = [];
            if (sliderStart) {
                let startSplit = sliderStart.split(":");
                let startHour = startSplit[0];
                let startMinute = startSplit[1];
                let endeSplit = sliderEnde.split(":");
                let endeHour = endeSplit[0];
                let endeMinute = endeSplit[1];
                if (startMinute !== '30') {
                    if (startHour.charAt(0) === '0') {
                        let ind = startHour.charAt(1);
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(ind); i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(ind); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    } else {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(startHour) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(startHour); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    }
                }
                if (startMinute === "30") {
                    vm.hours.push(sliderStart)
                    let ind = startHour.charAt(1);
                    if (startHour.charAt(0) === '0') {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(ind) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(ind) + 1; i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }

                    } else {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(startHour) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(startHour); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    }
                }
            } else {
                getTicksForSliderDefault()
            }
        }


        function getTicksForSliderDefault() {
            var quarterHours = ["00", "30"];
            for (var i = 0; i < 24; i++) {
                for (var j = 0; j < 2; j++) {
                    var time = i + ":" + quarterHours[j];
                    if (i < 10) {
                        time = "0" + time;
                    }
                    vm.hours.push(time);
                }
            }
            vm.hours.push("24:00");
            return vm.hours
        }


        vm.setNewStartDate = function (s) {
            var dayWeek = s.getDay();
            //vm.startDate = new Date(s.getFullYear(), s.getMonth(), s.getDate() - (dayWeek - 1));
            vm.startDate = new Date(s);
            if (s < new Date()) {
                vm.startDate = new Date();
            }
            initPlan();
        };

        vm.setNewDayDate = function (s) {
            vm.date = new Date(s.getFullYear(), s.getMonth(), s.getDate());
            initPlan(vm.date);
        };

        vm.gotoDateRelativeDay = function (offset) {
            var period = vm.meetingData.Buchungszeitraum;
            maxDate = moment().endOf("day").toDate();
            maxDate.setDate(maxDate.getDate() + ((period === 0) ? 365 : period));
            let date = moment(vm.date).add(offset, 'd');
            if (date <= maxDate) {
                vm.date = new Date(date);
                initPlan(vm.date);
            }
        };

        vm.goTodayDay = function () {
            var now = new Date();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            initPlan(vm.date);
        };

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        vm.getTermin = function (cell) {
            var appointments = BookingCalculationService.getAppointmentsForDate(cell.Start);
            appointments = BookingCalculationService.chooseAppointment(appointments);
            //if (vm.ressourcenBeliebig === true) {
            appointments.RIds = [appointments.RIds];
            appointments.RIdsAuswahl = [vm.selectedRessourcen]
            //}
            // else {
            //     appointments.RIds = [vm.selectedRessourcen];
            // }

            //ToDo Ressourcen zur Auswahl im Step3 übergeben
            SessionService.setAppointment(vm.meetingData.Nr, appointments);
            $state.go("ubersicht", {subcategory: vm.meetingData.Nr, meeting: appointments, cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
            sendHeight();
        };

        vm.gotoDateRelativeNextWeek = function () {
            vm.KW = vm.KW +1;
            vm.momentWeekStart = moment().year(vm.currentYear).week(vm.KW).startOf('week');
            vm.nowEndDate = moment(vm.momentWeekStart).add(6, 'days');
            vm.KWEnd = moment(vm.nowEndDate).isoWeek();
                vm.startDate = new Date(vm.momentWeekStart);
            // if (vm.startDate < new Date())
            //     vm.startDate = new Date();
            // if (vm.startDate > maxDate)
            //     vm.startDate = maxDate;

            initPlan();
        };

        vm.gotoDateRelativeLastWeek = function (offset) {
            vm.KW = vm.KW -1;
            vm.KWEnd = vm.KW;
            if (vm.KW === moment().isoWeek()) {
                if (vm.startDate < new Date())
                    vm.startDate = new Date();
                if (vm.startDate > maxDate)
                    vm.startDate = maxDate;
                goToToday();
            } else {
                vm.startDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + offset);
                // if (vm.startDate < new Date())
                //     vm.startDate = new Date();
                // if (vm.startDate > maxDate)
                //     vm.startDate = maxDate;
            }

            initPlan();
        };

        vm.goToday = function () {
            goToToday()
        };

        function goToToday() {
            vm.startDate = new Date();
            vm.KW = moment().isoWeek();
            vm.nowEndDate = moment().add(6, 'days');
            vm.KWEnd = moment(vm.nowEndDate).isoWeek();
            initPlan();
        }

        vm.toggleResource = function (resType, selected, resNr) {
            vm.selectedResType = resType;
            if (selected)
                vm.selectedAll[resType] = false;
            else if (_.findIndex(vm.appointmentResources[resType], {selected: true}) < 0)
                vm.selectedAll[resType] = true;

            vm.selectedNrs[resNr] = (selected) ? resType : "";
            if (selected && !_.includes(vm.selectedRessourcen, resNr)) {
                vm.selectedRessourcen.push(resNr);
                vm.ressourcenBeliebig = false
            } else if (!selected && _.includes(vm.selectedRessourcen, resNr)) {
                _.pull(vm.selectedRessourcen, resNr);
                if (vm.selectedRessourcen.length === 0) {
                    vm.ressourcenBeliebig = true;
                }
            }
            initPlan();

        };

        vm.clearResource = function (resType) {
            vm.selectedRessourcen = [];
            vm.selectedAll[resType] = true;
            vm.ressourcenBeliebig = true;
            _.forEach(vm.appointmentResources[resType], function (value) {
                value.selected = false;
            });
            _.forEach(vm.selectedNrs, function (value, type) {
                if (vm.selectedNrs[type] === resType)
                    vm.selectedNrs[type] = "";
            });

            initPlan();
        };

            
        let _lastSentHeight = 0;

        function sendHeight() {
            const container = document.querySelector('.container');

            setTimeout(() => {
                // CSS temporär injizieren, um alle vh-basierten Höhen zu überschreiben
                // (verhindert Feedback-Schleife – scrollHeight ignoriert overflow:hidden).
                const tempStyle = document.createElement('style');
                tempStyle.textContent =
                    '[ui-view="content"]{min-height:0!important}' +
                    '.height_kundenportal_basic,.height_kundenportal_high{height:auto!important}';
                document.head.appendChild(tempStyle);

                const height = container.scrollHeight;

                document.head.removeChild(tempStyle);

                // Nur senden, wenn sich die Höhe tatsächlich geändert hat.
                if (height !== _lastSentHeight) {
                    _lastSentHeight = height;
                    window.parent.postMessage({ type: 'setHeight', height }, '*');
                }
            }, 600);
        }


        function initPlan(dateDayView) {

            if (dateDayView) {
                vm.startDate = dateDayView
                maxDate = new Date(dateDayView.setHours(23, 59, 0, 0));
            }
            vm.weekDates = [];
            var start = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate());
            for (var i = 0; i < 7; ++i) {
                vm.weekDates.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                var tag = start.getDate();
                start.setDate(tag + 1);
            }

            vm.loading = true;
            vm.error = false;

            var filter = {};
            _.forEach(vm.appointmentResources, function (option, key) {
                if (!vm.selectedAll[key]) {
                    var selected = _.filter(vm.appointmentResources[key], {selected: true});
                    if (_.size(selected) > 0)
                        filter[selected[0].ArtNr] = _.map(selected, "ResNr");
                }
            });

            BookingService.getWeekMeetings(vm.startDate, vm.meetingData.Nr, filter).then(function (data) {
                return BookingCalculationService.calculateCalendar(data, maxDate)
            }).then(function (calendar) {
                vm.loading = false;
                vm.bis = vm.meetingData.BuchungszeitraumBis;

                vm.calendar = BookingCalculationService.getCalendar2(calendar.calendarTimes, calendar.rawData, vm.meetingData.Nachlauf);
                vm.emptyDays = BookingCalculationService.getEmptyDays();
                vm.calendarEmpty = (_.indexOf(vm.emptyDays, false) < 0);
                sendHeight();
            }).catch(function (err) {
                vm.loading = false;
                vm.error = true;
            });
        }

        function checkImage(type) {
            BookingService.getTerminImage(type.Nr).then(function (image) {
                vm.meetingData = vm.cookies.meetingData;
                vm.Bild = image;
            });
        }

        async function init() {
            vm.cookies = SessionService.checkSession();
            vm.Bild = null;

            if (_.isNil(vm.cookies.meetingData)) {
                unregisterEventHandler();
                $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
            } else {
                checkImage(vm.cookies.meetingData)
                // vm.meetingData = vm.cookies.meetingData;
                vm.stepsArray = await getTicksForSlider(vm.meetingData.StartTimeSlider, vm.meetingData.EndeTimeSlider);
                vm.bis = vm.meetingData.BuchungszeitraumBis;
                vm.SliderActiv = vm.meetingData.IsSlider;
                vm.slider = {
                    minValue: vm.meetingData.StartTimeSlider ? vm.meetingData.StartTimeSlider : "00:00",
                    maxValue: vm.meetingData.EndeTimeSlider ? vm.meetingData.EndeTimeSlider : "24:00",
                    options: {
                        showTicks: true,
                        stepsArray: vm.stepsArray,
                        draggableRange: true,
                        onChange: function () {
                            changeBackground()
                        },
                    }
                };
                BookingService.getResourcesForAppointment(vm.meetingData.Nr).then(function (resources) {
                    vm.lengthRessources = resources.length;
                    vm.appointmentResources = _.groupBy(resources, "ArtBezeichnung");
                    vm.selectedAll = {};
                    _.forEach(vm.appointmentResources, function (options, key) {
                        vm.selectedAll[key] = true;
                        _.forEach(options, function (option) {
                            option.selected = false;
                            vm.selectedNrs[option.ResNr] = "";
                        })
                    });

                });
                var period = vm.meetingData.Buchungszeitraum;
                maxDate.setDate(maxDate.getDate() + ((period === 0) ? 365 : period));
                vm.datepickerOptions = {
                    minDate: new Date(),
                    maxDate: maxDate
                };
                initPlan();

            }
        }

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('angebot', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), dt: SessionService.getAuthDtData()})
                }
            }
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = $localStorage.user && (!!($localStorage.user && $localStorage.user.username !== ''));
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
            vm.isTrainer = $stateParams.id === 'tt';
        }

        vm.goToAngebot = function () {
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };
    }

]);